var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgActivateDragModeBlue = function SvgActivateDragModeBlue(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#3aacc8",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.2,
    d: "m1 14 1.5-4.5m0 0 8-8c.5-.5 1.5-.5 2 0l2 2c.5.5.5 1.5 0 2l-8 8m-4-4 4 4m0 0L1 14"
  })));
};
export { SvgActivateDragModeBlue as ReactComponent };
export default __webpack_public_path__ + "17a906388d673d0f15ea8a81124d898f.svg";